import { Request } from "./request";
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { Md5 } from "./md5";
import { getOsVersion } from "./tools";
import { getDeviceId } from "./deviceId";
const { v4: uuidv4 } = require('uuid');


dayjs.extend(utc)
dayjs.extend(timezone)

export enum SDK_POINT {
    H5_SHELL_CONFIG_GET_SUCCESS = 412,
    H5_SHELL_CONFIG_GET_ERROR = 413
}

const osMap: any = {
    'miniprogramWx': '9',
    'h5': '3'
}

let query: any = new URLSearchParams(window.location.search);

const iwCode = query.get('iwCode')

export class SDKPoint {

    public static getLogId(){
        let logId = Md5.hashStr(uuidv4());
        return logId;
    }

    public static getCurrentTimeWithTimezone() {
        const now = dayjs.tz(dayjs(), 'Asia/Shanghai');
        const formattedTime = now.format('ZZ YYYY-MM-DD HH:mm:ss');
        return formattedTime;
    }

    public static getOs(pubCode: string){
        const pubParams = pubCode?.split('-')?.slice(-2)
        return pubParams?.[1]
    }

    public static getPlatform(pubCode: string){
        if(!pubCode){
            return osMap['h5']
        }
        const os = this.getOs(pubCode)
        return osMap?.[os] ?? osMap['h5']
    }

    public static getProjectId(channelId: string){
        return channelId?.split('-')?.[0]
    }

    public static getSubGameId(channelId: string){
        return channelId?.split('-')?.[1]
    }

    public static getAdId(commonAdId: string){
        return commonAdId
    }

    public static getTransfer(){
        const zdInfo = query.get('zdinfo') ?? '';
        if (zdInfo) {
            try {
                const zdInfoMap = JSON.parse(window.atob(zdInfo));
                return zdInfoMap?.transfer ? Number(zdInfoMap?.transfer) : 0
            } catch (error) {
                console.log('格式化transfer错误', error)
                return 0
            }
        }
        return 0
    }

    public static getDeviceOs(){
        let sign = getOsVersion().split(' ')[0];
        switch(sign){
            case 'windows':
                return '3';
                break;
            case 'ios':
                return '1';
                break;
            case 'android':
                return '2';
                break;
            default:
                return '0';
        }
    }

    public static getUserAgent(){
        return window.navigator.userAgent
    }

    public static getPointParams(step: SDK_POINT, sessionId: string, params: any) {
        const platform = this.getPlatform(params?.pubCode);
        const pointParams = {
            log_id: this.getLogId(),
            event_time: this.getCurrentTimeWithTimezone(),
            platform,
            device_id: getDeviceId(),
            project_id: this.getProjectId(iwCode),
            subgame_id: this.getSubGameId(iwCode),
            channel_id: params?.channelId ?? iwCode,
            ad_id: this.getAdId(params?.adId),
            device_os: this.getDeviceOs(),
            step,
            session_id: sessionId,
            event: 'pubsdk_behavior_trace',
            transfer: this.getTransfer(),
            user_agent: this.getUserAgent(),
            open_id: params?.openId || '',
            traffic_provider: params?.trafficProvider || '',
            device_model: params?.deviceModel || '',
            device_manufacturer: params?.deviceManufacturer || '',
            game_package_id: params?.gamePackageId || '',
        }
        return pointParams
    }

    public static report(step: SDK_POINT, sessionId: string, params: any) {
        if(!process.env.REACT_APP_SDK_GLOG_URL){
            console.error("上报错误, glogUrl为空")
            return 
        }
        const pointParams = this.getPointParams(step, sessionId, params)
        Request.create({
            url: process.env.REACT_APP_SDK_GLOG_URL,
            data: [pointParams],
            type: 'POST',
            header: {
                "Content-Type": "text/plain;charset=UTF-8"
            }
        }).then(res => {
            
        }).catch(error => {
            console.error('数据上报错误', error)
        })

    }
}